import styled from 'styled-components';
import { COLORS } from 'apps/web_forms/utils/constants';

const PlaceHolder = styled.div`
  color: ${(props) => (!props.error ? COLORS.fadedGrey : COLORS.red)};
  text-align: center;
  box-sizing: border-box;
  font-size: 2em;
  padding: 1em;
`;

export default PlaceHolder;
export { PlaceHolder };
